// Libraries
import React from 'react';

// Supermove
import {gql, useQuery} from '@supermove/graphql';
import {Form} from '@supermove/hooks';
import {UserModel} from '@supermove/models';

// App
import DropdownInput from '@shared/design/components/DropdownInput';
import FieldInput from '@shared/design/components/Field/FieldInput';

const CompanyAccountCalendarSelect = ({
  index,
  accountGrantId,
  form,
  name,
  isRequired,
}: {
  index: number;
  accountGrantId: string | undefined;
  form: Form;
  name: string;
  isRequired: boolean;
}) => {
  const {data, loading} = useQuery<{viewer: UserModel}>(CompanyAccountCalendarSelectQuery, {
    variables: {
      accountGrantId,
    },
    skip: !accountGrantId,
  });

  const calendarOptions =
    data?.viewer.viewingOrganization.accountGrant?.editableCalendars.map((calendar) => ({
      value: calendar.id,
      label: calendar.name,
    })) || [];

  return (
    <FieldInput
      {...form}
      index={index}
      label={'Calendar'}
      name={name}
      component={DropdownInput}
      isResponsive
      isRequired={isRequired}
      input={{
        options: calendarOptions,
        setFieldValue: form.setFieldValue,
        placeholder: `Select calendar`,
        isPortaled: true,
        isLoading: loading,
        style: {flex: 1},
      }}
    />
  );
};

// ------------------------------------------------------------
// Data
// ------------------------------------------------------------

const CompanyAccountCalendarSelectQuery = gql`
  query CompanyAccountCalendarSelectQuery($accountGrantId: Int!) {
    viewer {
      id
      viewingOrganization {
        id
        accountGrant(accountGrantId: $accountGrantId) {
          id
          editableCalendars {
            id
            name
          }
        }
      }
    }
  }
`;

export default CompanyAccountCalendarSelect;
